import { toCSSPixel } from '../../../../utils/styles'

import { DOC_FLOW_SELECT_AREA_INFO_MAX_HEIGHT_CSS_VARIABLE } from './useDocFlowPdfSelectArea.constants'

export function setDocFlowSelectAreaInfoMaxHeight({
  availableHeight,
  elements,
}) {
  elements.floating.style.setProperty(
    DOC_FLOW_SELECT_AREA_INFO_MAX_HEIGHT_CSS_VARIABLE,
    toCSSPixel(Math.round(availableHeight))
  )
}
